import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, Typography, Divider, Button, TextField, CircularProgress } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";
import { getTerimaanByNoAkaunAll } from "api/terimaan";
import { apiGetQrAkaun } from "api/qr";

// Format helper
const fmtRM = (v) => {
  const n = Number.parseFloat(v || 0);
  return n.toFixed(2);
};

export default function QRPage() {
  const [tab, setTab] = useState(0);
  const [data, setData] = useState({});
  const [amaunBayaran, setAmaunBayaran] = useState(0);
  const [terimaan, setTerimaan] = useState([]);
  const [loadingTerimaan, setLoadingTerimaan] = useState(false);
  const [loadingAkaun, setLoadingAkaun] = useState(false);

  const params = useParams();
  const location = useLocation();

  // Resolve no_akaun from /qr/:no_akaun or ?no_akaun= query
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const fromQuery = searchParams.get("no_akaun");
    const no_akaun = params.no_akaun || fromQuery || null;
    // Load Akaun aggregated data
    if (no_akaun) {
      setLoadingAkaun(true);
      apiGetQrAkaun(no_akaun)
        .then((res) => setData(res?.data || {}))
        .catch(() => setData({ no_akaun }))
        .finally(() => setLoadingAkaun(false));
    } else {
      setData({});
    }
    // Load sejarah (terimaan) for this account
    if (no_akaun) {
      setLoadingTerimaan(true);
      getTerimaanByNoAkaunAll(no_akaun)
        .then((res) => {
          const rows = Array.isArray(res?.data) ? res.data : [];
          // Sort by tarikh (prefer tarikh_simpan, fallback tarikh_resit) descending for latest first
          const norm = rows
            .map((r) => ({
              ...r,
              _tarikh:
                r.tarikh_simpan || r.tarikh_resit || r.tarikh || r.created_at || null,
            }))
            .sort((a, b) => {
              const da = a._tarikh ? new Date(a._tarikh).getTime() : 0;
              const db = b._tarikh ? new Date(b._tarikh).getTime() : 0;
              return db - da;
            });
          setTerimaan(norm);
        })
        .catch(() => setTerimaan([]))
        .finally(() => setLoadingTerimaan(false));
    } else {
      setTerimaan([]);
    }
  }, [params.no_akaun, location.search]);

  const handleTabChange = (e, v) => setTab(v);

    // Custom color for payment button
    const payButtonSx = {
      py: 1.5,
      backgroundColor: '#b71c1c', // dark red
      color: '#fff',
      '&:hover': {
        backgroundColor: '#7f1010',
      },
    };

    return (
      <Box sx={{ maxWidth: 520, mx: "auto", p: 2, bgcolor: "rgba(255, 218, 236, 1)", minHeight: "100vh" }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="fullWidth"
          TabIndicatorProps={{ style: { backgroundColor: 'rgba(255, 218, 236, 1)' } }}
          sx={{
            // Remove default background
            backgroundColor: 'transparent',
            minHeight: 48,
            mb: 1,
          }}
        >
          <Tab
            label={<b>AKAUN</b>}
            sx={{
              backgroundColor: tab === 0 ? 'rgb(179, 0, 87)' :'rgba(255, 218, 236, 1)',
              color: tab === 0 ? 'rgba(255, 255, 255, 1) !important' : 'rgba(0, 0, 0, 1)',
              fontWeight: tab === 0 ? 700 : 400,
              minHeight: 48,
              transition: 'background 0.2s',
            }}
          />
          <Tab
            label={<b>SEJARAH</b>}
            sx={{
              backgroundColor: tab === 1 ? 'rgb(179, 0, 87)' : 'rgba(255, 218, 236, 1)',
              color: tab === 1 ? 'rgba(255, 255, 255, 1) !important' : 'rgba(0, 0, 0, 1)',
              fontWeight: tab === 1 ? 700 : 400,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              minHeight: 48,
              transition: 'background 0.2s',
            }}
          />
        </Tabs>
      {tab === 0 && (
        <Box sx={{ mt: 2 }}>
          {loadingAkaun ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress size={28} />
            </Box>
          ) : (
            <>
              <Typography variant="subtitle2"><b>Nama:</b> {data.nama || "-"}</Typography>
              <Typography variant="subtitle2"><b>Alamat:</b> {data.alamat || "-"}</Typography>
              <Typography variant="subtitle2"><b>No Akaun:</b> {data.no_akaun || "-"}</Typography>
              <Typography variant="subtitle2"><b>Perkara:</b> {data.perkara || "-"}</Typography>
              <Typography variant="subtitle2"><b>Tunggakan:</b> RM {fmtRM(data.tunggakan)}</Typography>
              <Typography variant="subtitle2"><b>Bil Semasa:</b> RM {fmtRM(data.bil_semasa)}</Typography>
              <Typography variant="subtitle2"><b>Jumlah:</b> RM {fmtRM(data.jumlah)}</Typography>
            </>
          )}
          <Divider sx={{ my: 3 }} />
          <Typography align="center" variant="h6">PEMBAYARAN</Typography>
          <TextField
            label="Amaun bayaran"
            type="number"
            value={amaunBayaran}
            onChange={e => setAmaunBayaran(e.target.value)}
            fullWidth
            sx={{ my: 3 }}
          />
          <Typography variant="body2" sx={{ mb: 2 }}>
            <Box fontWeight='fontWeightMedium' display='inline' color='red'>Nota Penting:</Box><br />
            <Box color='red'>Pihak KEJORA menggunakan perkhidmatan gerbang pembayaran on-line</Box> <Box fontWeight='fontWeightMedium' display='inline' color='red'>&quot;SenangPay&quot;</Box> <Box color='red'>yang diuruskan oleh Simplepay Gateway Sdn. Bhd. Paparan Seller FPX, notifikasi emel dan SMS yang anda terima akan tercatat</Box> <Box fontWeight='fontWeightMedium' display='inline' color='red'>&quot;Simplepay Gateway Sdn. Bhd&quot;</Box>. <Box color='red'>Harap maklum!</Box>
          </Typography>
          <Button variant="contained" fullWidth sx={payButtonSx}>
            Klik untuk bayar
          </Button>
        </Box>
      )}
      {tab === 1 && (
        <Box sx={{ mt: 2 }}>
          {loadingTerimaan ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress size={28} />
            </Box>
          ) : terimaan.length === 0 ? (
            <Typography align="center" sx={{ color: "text.secondary" }}>
              Tiada rekod terimaan.
            </Typography>
          ) : (
            <Box>
              {terimaan.map((t, idx) => {
                const tarikhRaw = t.tarikh_simpan || t.tarikh_resit || t._tarikh;
                const tarikh = tarikhRaw
                  ? new Date(tarikhRaw).toISOString().slice(0, 10)
                  : "-";
                const saluran = t.saluran_bayaran || t.saluran || "-";
                const noTransaksi = t.no_resit || t.no_transaksi || "-";
                const amaun = Number.parseFloat(t.jumlah || 0);
                return (
                  <Box key={idx} sx={{ pb: 1.5 }}>
                    <Typography variant="subtitle2"><b>Tarikh Transaksi</b>&nbsp;&nbsp;: {tarikh}</Typography>
                    <Typography variant="subtitle2"><b>Saluran Bayaran</b>&nbsp;: {saluran}</Typography>
                    <Typography variant="subtitle2"><b>No Transaksi</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: {noTransaksi}</Typography>
                    <Typography variant="subtitle2"><b>Amaun Bayaran</b>&nbsp;&nbsp;: {amaun.toFixed(2)}</Typography>
                    {idx !== terimaan.length - 1 && <Divider sx={{ my: 1.5 }} />}
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
